var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _rect9, _rect10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 446,
    viewBox: "0 0 255 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 204,
    width: 255,
    height: 36,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 358,
    width: 255,
    height: 88,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 253,
    height: 36,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 52,
    width: 192,
    height: 36,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 256,
    width: 192,
    height: 36,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 102,
    width: 192,
    height: 36,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 306,
    width: 192,
    height: 36,
    rx: 8,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 152,
    width: 192,
    height: 36,
    rx: 8,
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 69.5,
    r: 15.5,
    stroke: "#D9D9D9",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 120.5,
    r: 15.5,
    stroke: "#D9D9D9",
    strokeWidth: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 171.5,
    r: 18.5,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 253,
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 305,
    width: 40,
    height: 40,
    fill: "url(#pattern1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_750_2272",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_750_2272",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_750_2272",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormMobile);
export default __webpack_public_path__ + "static/media/Form-mobile.b699378dc9f97780daf4bd904dea152f.svg";
export { ForwardRef as ReactComponent };